import { Box, FormControlLabel, Paper, Stack, Switch } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { getEquipmentCategoryList } from "../../Api/Equipment";
import { EquipmentCategory } from "../../Objects/EquipmentCategory";
import CategoryTitle from "../atoms/CategoryTitle";
import EquipmentCategoryList from "./EquipmentCategoryList";

const StoreDetailEquipment: React.FC = () => {
    let { enqueueSnackbar } = useSnackbar()

    const [equipmentCategoryList, setEquipmentCategoryList] = React.useState<EquipmentCategory[]>([])

    const [hiddenDeleteEquip, setHiddenDeleteEquip] = React.useState<boolean>(true)

    React.useEffect(() => {
        const controller = new AbortController()
        getEquipmentCategoryList({signal: controller.signal}).then(result => {
            setEquipmentCategoryList(result.list)
        }).catch((e: any) => {
            if( e.__CANCEL__ ) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            }else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })
        return () => {
            controller.abort()
        }
    }, [enqueueSnackbar])

    return (
        <Paper sx={{ mt: 2, pb: 2 }}>
            <CategoryTitle
                text="機材設定"
            />
            <Stack
                direction="row"
                justifyContent="right"
            >
                <FormControlLabel
                    control={<Switch
                        checked={hiddenDeleteEquip}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setHiddenDeleteEquip(event.target.checked)
                        }}
                    />}
                    label="削除済みアイテムを表示しない"
                />
            </Stack>
            <Box
                sx={{
                    m: 2
                }}
            >
                {equipmentCategoryList &&
                    <EquipmentCategoryList
                        equipmentCategoryList={equipmentCategoryList}
                        hiddenDeleteEquip={hiddenDeleteEquip}
                    />
                }
            </Box>
        </Paper>
    );
}

export default StoreDetailEquipment